import { FC, HTMLAttributes, JSX } from 'react';

import logo from '/logo.svg?url';

const LogoIcon: FC<HTMLAttributes<HTMLDivElement>> = ({
  ...props
}): JSX.Element => (
  <div style={{ width: '22px', height: '24px' }} {...props}>
    <img style={{ width: '100%', height: '100%' }} src={logo} alt="logo" />
  </div>
);
export default LogoIcon;
